
export class MailScenario {
manageBody: boolean;
manageFiles: boolean;
manageRecipients: boolean;
summarize: boolean;
}

